// src/components/CustomControl.js
import Control from 'ol/control/Control'
import { useEffect, useRef } from 'react'
import useMapStore from 'store/map'

import styles from './ZoomToRobot.module.css'

interface Props {
  onClick: () => void
  embedded?: boolean
}

const CustomControl = ({ onClick, embedded = false }: Props) => {
  const map = useMapStore(s => s.map)

  const controlRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const element = controlRef.current
    if (embedded || !map || !element) return

    const zoomToRobotControl = new Control({
      element,
    })

    map.addControl(zoomToRobotControl)

    return () => {
      map?.removeControl(zoomToRobotControl)
    }
  }, [map, embedded])

  return (
    <div
      ref={controlRef}
      className={`ol-unselectable ol-control-custom${embedded ? '' : ' ol-control'}`}
      style={embedded ? undefined : { bottom: '300px', right: '.5em' }}
    >
      <button onClick={onClick} className={styles.icon}></button>
    </div>
  )
}

export default CustomControl
